export const ROUTES = {
    DASHBOARD: "/",
    SETTINGS: "/settings",
    USERS: "/users",
    ORDERS: "/orders",
    NEW_PARTNERS: "/new-partners",
    NEW_PARTNER_PROFILE: "/new-partners/:id",
    PARTNERS: "/partners",
    PRODUCTS: "/products",
    PRODUCT_DETAILS: "/products/:id",
    CATEGORIES: "/categories",
    SUPPORTS: "/supports",
    SUPPORT_CHAT: "/support-chats/:id",
    COUPONS: "/coupons",
    REVIEWS_ORDERS: "/reviews/orders",
    REVIEWS_PRODUCTS: "/reviews/products",
    REVIEWS_PARTNERS: "/reviews/partners",
    BILLS: "/bills",
    CURRENCIES_EXCHANGE: "/currencies-exchange",
    ADMINS: "/admins",
    LOGIN: "/login",
    LOGOUT: "/logout",

    EARNING_REPORT: "/earning-report",
    TOP_ENTITIES_REPORT: "/top-entities-report",
} as const;

export type RouteValue = typeof ROUTES[keyof typeof ROUTES];